import { render, staticRenderFns } from "./DialogCopyIdea.vue?vue&type=template&id=1dbf15e2"
import script from "./DialogCopyIdea.vue?vue&type=script&lang=js"
export * from "./DialogCopyIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports